import { css } from 'styled-components';

import { colors } from '#/theme/theme';

export const listingRichTextListPadding = 48;

export const listingRichTextStyles = css`
  font-size: 16px;
  line-height: 1.75;
  color: ${colors.darkContentGrey};

  > :first-child {
    margin-top: 0;
  }

  > :last-child {
    margin-bottom: 0;
  }

  p {
    margin: 8px 0;
  }

  h4 strong {
    font-weight: inherit;
  }

  ul {
    padding-left: ${listingRichTextListPadding}px;
  }

  ol {
    list-style: decimal;
    padding-left: ${listingRichTextListPadding}px;

    &::before {
      content: none;
    }
  }

  ol ol {
    list-style-type: lower-alpha;
  }

  ol ol ol {
    list-style-type: lower-roman;
  }

  ul li::marker {
    font-size: 0.7em;
  }
`;
